<div class="certificaciones-container">
  <h2 class="section-title">{{'CERTIFICATIONS.TITLE' | translate}}</h2>
  <p class="cert-text">
    {{'CERTIFICATIONS.TEXT_1' | translate}}
  </p>
  <!-- <a mat-raised-button color="accent" [href]="'https://wa.me/50672195203?text=Prad%20Academy,%20necesito%20ayuda.'" target="_blank">
   <mat-icon svgIcon="whatsapp"></mat-icon>
    {{'CERTIFICATIONS.HELP' | translate}}
  </a> -->
</div>
